<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">
      {{ ('MENU.CREATE_BACKUP' | translate) }}
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
    </div>
  </div>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field class="dish-name min-width-400"  appearance="fill">
      <mat-label>{{ 'MENU.SIZE_SCALES.NAME' | translate }}</mat-label>
      <input matInput type="text" formControlName="menuBackupName">
    </mat-form-field>

    <div class="form-bottom" style="display: flex">
      <button
        class="button"
        mat-button
        type="submit"
        (submit)="submit()"
        style="flex: auto"
      >{{ 'MENU.SAVE' | translate }}
      </button>
    </div>
  </form>
</div>

